import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol viewBox=\"0 0 11 7\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-up\"><path d=\"M9.845 5.45L5.311.47.837 5.45l.6.65 3.875-4.311 3.933 4.31.6-.649z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol